const GOOGLE_CALENDAR_OAUTH_STATE_KEY = "mem.google_calendar.oauth_state";

export const writeGoogleCalendarOAuthState = (state: string) => {
  window.localStorage.setItem(GOOGLE_CALENDAR_OAUTH_STATE_KEY, state);
};

export const readGoogleCalendarOAuthState = (): string | null => {
  return window.localStorage.getItem(GOOGLE_CALENDAR_OAUTH_STATE_KEY);
};

export const clearGoogleCalendarOAuthState = () => {
  window.localStorage.removeItem(GOOGLE_CALENDAR_OAUTH_STATE_KEY);
};
